var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_181:60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.78717 12.25H1.24748V4.07137H3.78717V12.25ZM2.5158 2.95575C1.7038 2.95575 1.04492 2.28288 1.04492 1.47088C1.04492 1.08077 1.19989 0.706652 1.47573 0.430809C1.75157 0.154967 2.1257 0 2.5158 0C2.9059 0 3.28002 0.154967 3.55586 0.430809C3.83171 0.706652 3.98667 1.08077 3.98667 1.47088C3.98667 2.28288 3.3278 2.95575 2.5158 2.95575ZM13.2923 12.25H10.7583V8.26875C10.7583 7.31981 10.739 6.10313 9.43792 6.10313C8.11755 6.10313 7.91498 7.13387 7.91498 8.2005V12.25H5.37792V4.07137H7.81349V5.187H7.84892C8.18798 4.54431 9.01617 3.86619 10.2517 3.86619C12.822 3.86619 13.2945 5.55888 13.2945 7.75731V12.25H13.2923Z",
    fill: "#D0CBD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181:60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.169922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.1fdefd0e56fea6d3fbdd24ad47fcdeb1.svg";
export { ForwardRef as ReactComponent };